<template>
	<div class="mx-3 paypal-payment-root">
		<BackHeader class="mb-4" @onBackClicked="onBackClicked">Back to payment options</BackHeader>
		<div class="title">PayPal Payment Integration</div>
		<div class="row mt-4">
			<div class="col-4">
<!--				<div class="subtitle pb-2">PayPal Account Integration</div>-->
				<div>
					Integrate your PayPal account and allow customers to checkout using PayPal.
				</div>

			</div>
			<div class="col">
				<div class="card py-4 px-4 qwoach-form expand-error">

					<el-form :model="paymentIntegrationItemData" :rules="rules" ref="mainForm">

<!--						<FormTextRow-->
<!--							prop="email"-->
<!--							:showDivider="false"-->
<!--							:isVertical="true"-->
<!--							title="PayPal account email"-->
<!--							v-model="paymentIntegrationData.email"/>-->
						<FormTextRow
							class="mb-0"
							prop="clientId"
							:showDivider="false"
							:isVertical="true"
							:disabled="isIntegrated"
							title="Your PayPal Client Id"
							v-model="paymentIntegrationItemData.clientId"/>
						<div class="mb-2">
							<small>
							<a href="https://qwoach.com/blog/how-to-connect-paypal-to-your-qwoach-account/" target="_blank" @click="payPalClientIdInstructionsClicked">Where do I find this?</a>
							</small>
						</div>

						<FormTextRow
							prop="secret"
							:showDivider="false"
							:isVertical="true"
							:placeholder-shown="!paymentIntegrationItemData.secret.length"
							:disabled="isIntegrated"
							type="secure"
							title="Your PayPal Secret"
							v-model="paymentIntegrationItemData.secret"/>
					</el-form>
				</div>

				<div class="mt-4 ml-4" v-if="!isIntegrated">
					<el-button type="primary" size="small" @click="onConnectPressedPayPal">Connect</el-button>
				</div>


			</div>
		</div>
	</div>
</template>

<script>
	import FormTextRow from "@/core/components/Form/FormTextRow.vue";
	import BasePaymentIntegrationView
		from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/BasePaymentIntegrationView.vue";
	import BackHeader from "@/core/components/BackHeader.vue";
	import PayPalIntegrationItem from "@shared/Billing/PayPalIntegrationItem";

	export default {
		name: "PayPalPaymentIntegration",
		extends: BasePaymentIntegrationView,
		components: {BackHeader, FormTextRow},

		data: () => ({
			rules:{
				clientId: [
					{
						required: true,
						whitespace: false,
						message: "Client id can't be empty",
						trigger: 'validate'
					},
				],
				secret: [
					{
						required: true,
						whitespace: false,
						message: "Secret can't be empty",
						trigger: 'validate'
					},
				],
			}
		}),

		methods: {
			createPaymentIntegrationItem(){
				return new PayPalIntegrationItem()
			},

			payPalClientIdInstructionsClicked(){
				this.$analyticManager.trackEvent("PayPal ClientId instructions clicked", this.analyticsPropsMethod())
			},

			validateIntegration(paymentIntegrationItem) {
				return this.$dataManager.apiPostPayPalIntegrationValidate(paymentIntegrationItem)
			},

			async onConnectPressedPayPal() {
				let res = await this.onConnectPressed()
				if(res){
					// this.$analyticManager.logClick("connect_paypal")
				}
			},

			showInvalidIntegrationError(error){
				let _ = this.$analyticManager.trackEvent("PayPal integration failed", this.analyticsPropsMethod())
				this.handleError(error, "Can't connect PayPal account: incorrect Client Id or secret. Please double check and try again.", 5000)
			},

		},

		computed: {
			isIntegrated(){
				return this.paymentIntegrationItemData.integrated()
			}
		}

	}
</script>

<style lang="scss">

.paypal-payment-root{
	.mb-0 {
		.el-form-item:not(.is-error){
			margin-bottom: 0;
		}
	}
}


</style>
